import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20newsroom%20atmosphere%20with%20scattered%20newspaper%20headlines%20floating%20in%20air%20warm%20dark%20crimson%20and%20deep%20orange%20tones%20with%20soft%20golden%20highlights%20cinematic%20composition%20editorial%20photography%20rich%20texture%20high%20contrast%20moody%20aesthetic%20dynamic%20movement%20sense%20of%20urgency%20breaking%20news%20vibe&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="今日吃瓜 - 全网热门事件聚合平台"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="flex items-center gap-3 mb-6">
          <span className="px-4 py-1.5 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-bold uppercase tracking-wider">
            实时更新中
          </span>
          <span className="px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs font-medium backdrop-blur-sm">
            51在线入口已更新
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 text-center leading-tight max-w-4xl">
          全网热门事件
          <br />
          <span className="text-accent-400">一站式吃瓜</span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-background-50/80 text-center max-w-2xl leading-relaxed">
          结构化入口聚合全网热门事件、独家黑料曝光与每日吃瓜大赛，实时更新51在线资源，方便吃瓜群众一站式浏览最新动态
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/remen-dagua"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-bold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer flex items-center gap-2"
          >
            <i className="ri-fire-line text-lg w-5 h-5 flex items-center justify-center"></i>
            热门大瓜必看
          </Link>
          <Link
            to="/category/expose"
            className="px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-background-50/20 transition-all duration-200 cursor-pointer flex items-center gap-2"
          >
            <i className="ri-spy-line text-lg w-5 h-5 flex items-center justify-center"></i>
            黑料独家曝光
          </Link>
        </div>

        {/* Stats Row */}
        <div className="mt-10 flex items-center gap-6 md:gap-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">1280+</div>
            <div className="text-xs text-background-50/60 mt-1">热门事件</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">860+</div>
            <div className="text-xs text-background-50/60 mt-1">独家爆料</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">5.2W+</div>
            <div className="text-xs text-background-50/60 mt-1">吃瓜群众</div>
          </div>
        </div>
      </div>
    </section>
  );
}
